import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
	{
		path: 'signin',
		canActivate: [],
		loadChildren: () => import('./signin/signin.module').then( m => m.SigninModule)
	},
	{
		path: '',
		loadChildren: () => import('./interface/interface.routes').then(mod => mod.routes),
		canActivate: [MsalGuard]
	}
];
